var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Elpong from 'elpong';
var ZevensterAjaxService = /** @class */ (function () {
    function ZevensterAjaxService() {
        this.scheme = Elpong.get('greenplease');
        this.collection = this.scheme.select('zevenster_purchases');
    }
    ZevensterAjaxService.prototype.fetchPurchases = function (admin) {
        if (admin === void 0) { admin = false; }
        return __awaiter(this, void 0, void 0, function () {
            var o;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        o = admin ? { headers: { 'X-Greenplease-Admin-Response': 'true' } } : {};
                        if (!this.getAllPromise)
                            this.getAllPromise = this.collection.actions.getAll(o);
                        return [4 /*yield*/, this.getAllPromise];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.collection.array({ no_new: true })];
                }
            });
        });
    };
    ZevensterAjaxService.prototype.fetchPurchase = function (purchaseId, admin) {
        if (admin === void 0) { admin = false; }
        return __awaiter(this, void 0, void 0, function () {
            var o, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        o = admin ? { headers: { 'X-Greenplease-Admin-Response': 'true' } } : {};
                        _a = this.collection.find(purchaseId);
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.collection.actions.getOne(purchaseId, o)];
                    case 1:
                        _a = (_b.sent()) && this.collection.find(purchaseId);
                        _b.label = 2;
                    case 2: return [2 /*return*/, _a];
                }
            });
        });
    };
    ZevensterAjaxService.prototype.fetchPurchasedAreaIds = function () {
        return __awaiter(this, void 0, void 0, function () {
            var purchases;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchPurchases()];
                    case 1:
                        purchases = _a.sent();
                        return [2 /*return*/, purchases.reduce(function (ac, e) {
                                if (!e.fields.paid)
                                    return ac;
                                var areas = e.fields.areas;
                                areas.forEach(function (i) { return ac.add(i); });
                                return ac;
                            }, new Set())];
                }
            });
        });
    };
    ZevensterAjaxService.prototype.fetchPurchaseByAccessCode = function (accessCode) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.collection.actions.getOneByAccessCode({
                            headers: {
                                'X-Greenplease-Purchase-Access-Code': accessCode
                            }
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.collection.buildOrMerge(response.data)];
                }
            });
        });
    };
    ZevensterAjaxService.prototype.postAndPay = function (purchase) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, purchase.actions.post({ data: purchase.fields })];
                    case 1:
                        _a.sent();
                        window.location.href = purchase.fields.payment_url;
                        return [2 /*return*/];
                }
            });
        });
    };
    return ZevensterAjaxService;
}());
export { ZevensterAjaxService };
//# sourceMappingURL=zevenster-ajax.service.js.map